import { useEffect, useState } from "react";

// Browsers slow a background tab's timers to a crawl, so on return every queued deal / chip / payout animation used to
// play back at once. Coming back to the tab instead redraws the table fresh at the current moment: `resync` is a key
// that remounts the table (dropping stale timers) and `instant` switches animations off for a beat while it settles.
export function useTabReturn(minAwayMs = 1500) {
  const [resync, setResync] = useState(0);
  const [instant, setInstant] = useState(false);
  useEffect(() => {
    let hiddenAt = document.hidden ? Date.now() : null;
    let t;
    const onVis = () => {
      if (document.hidden) { hiddenAt = Date.now(); return; }
      if (hiddenAt && Date.now() - hiddenAt >= minAwayMs) {
        setResync((k) => k + 1);
        setInstant(true);
        clearTimeout(t);
        t = setTimeout(() => setInstant(false), 1200);
      }
      hiddenAt = null;
    };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearTimeout(t); document.removeEventListener("visibilitychange", onVis); };
  }, [minAwayMs]);
  return { resync, instant };
}
